const shipping = {
    free_shipping: 'Free Delivery',
    standard_shipping: 'Standard Delivery',
    express_shipping: 'Express Delivery',
    free_shipping_desc: 'For orders over €50 - 3-5 business days. Available only in the Netherlands.',
    standard_shipping_desc: '3-5 business days. Available only in the Netherlands.',
    express_shipping_desc: '1-2 business days. Available only in the Netherlands.',
    netherlands_only: 'Available only in the Netherlands'
};

export default shipping;
